import * as React from 'react';
import { styled } from '@linaria/react';

import { useColorMode } from '@/components/UserPreferencesProvider';
import SvgWithGrid from '@/components/SvgWithGrid';
import ColorModeContainer from '@/components/ColorModeContainer';

interface Props {
  size?: number;
  viewboxSize?: number;
  children: React.ReactNode;
  outsideChildren?: React.ReactNode;
}

function CustomSvg({
  size = 250,
  viewboxSize = 32,
  children,
  outsideChildren,
}: Props) {
  const colorMode = useColorMode();

  // STOPSHIP: This whole business seems funky. Does this actually work??

  return (
    <SvgWrapper
      data-color-mode={colorMode}
      colorMode="dark"
      style={{ width: size, height: size }}
    >
      <Svg
        gridGap={2}
        lineWidth={0.1}
        viewBox={`0 0 ${viewboxSize} ${viewboxSize}`}
        style={{ width: size, height: size }}
      >
        {children}
      </Svg>
      {outsideChildren}
    </SvgWrapper>
  );
}

const SvgWrapper = styled(ColorModeContainer)`
  position: relative;
  margin: 16px auto 32px;

  &[data-color-mode='light'] {
    border: 1px solid var(--color-gray-300);
    outline: 12px solid var(--color-background);
    border-radius: 4px;
  }
`;

const Svg = styled(SvgWithGrid)`
  display: block;
  outline: 1px solid var(--color-gray-300);
  border-radius: 4px;
`;

export default CustomSvg;
